import React, { useEffect, useState } from "react";
import useMousePosition from "./useMousePosition";

const useSimpleModal = ({ content, open, setOpen }) => {
  const mousePosition = useMousePosition();

  const [pos, setPos] = useState({ x: 0, y: 0 });

  function openModal() {
    setOpen(true);
  }

  useEffect(() => {
    if (open) setPos({ x: mousePosition.x, y: mousePosition.y });
  }, [open]);

  return {
    open: openModal,
    element: (
      <div className="divRow" style={{ position: "relative" }}>
        {open && (
          <div>
            <div className="overlayClear" onClick={() => setOpen(null)} />
            <div
              style={{
                position: "fixed",
                left: `${pos.x}px`,
                top: `${pos.y}px`,
              }}
            >
              <div style={{ zIndex: 1 }}>{content}</div>
            </div>
          </div>
        )}
      </div>
    ),
  };
};

export default useSimpleModal;
